import styled from 'styled-components'
import { Tabs } from 'antd'

export const TabsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fafbfc;
  border-radius: 8px;
  overflow: hidden;
  margin-left: 6px; // Add left margin for spacing from left section
`

export const StyledTabs = styled(Tabs)`
  height: 100%;
  
  .ant-tabs-nav {
    background: white;
    margin: 0;
    padding: 8px 12px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    
    &::before {
      border-bottom: none;
    }
  }
  
  .ant-tabs-tab {
    padding: 5px 8px;
    margin: 0 1px 0 0;
    font-size: 13px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.65);
    background: transparent;
    border: none;
    border-radius: 6px 6px 0 0;
    transition: all 0.2s;
    
    &:hover {
      color: #5c7cfa;
      background: rgba(92, 124, 250, 0.05);
    }
    
    &.ant-tabs-tab-active {
      color: #5c7cfa;
      background: rgba(92, 124, 250, 0.08);
      
      .ant-tabs-tab-btn {
        color: #5c7cfa;
        font-weight: 600;
      }
    }
  }
  
  .ant-tabs-ink-bar {
    background: #5c7cfa;
    height: 2px;
  }
  
  .ant-tabs-content {
    height: calc(100% - 46px);
    padding: 12px;
    background: white;
  }
  
  .ant-tabs-tabpane {
    height: 100%;
    overflow-y: auto;
    
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.1);
      border-radius: 3px;
      
      &:hover {
        background: rgba(0, 0, 0, 0.15);
      }
    }
  }
`

export const TabHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  margin-bottom: 12px;
  padding: 0;
  background: transparent;
  border-radius: 0;
  border: none;
`

export const FilterButton = styled.button<{ $active?: boolean; $danger?: boolean; $first?: boolean }>`
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 500;
  height: 28px;
  border-radius: ${props => props.$first ? '4px' : '0'};
  border: 1px solid ${props => props.$active ? '#5c7cfa' : 'rgba(0, 0, 0, 0.15)'};
  background: ${props => props.$active ? '#5c7cfa' : 'white'};
  color: ${props => props.$active ? 'white' : (props.$danger ? '#ff4d4f' : 'rgba(0, 0, 0, 0.65)')};
  cursor: pointer;
  transition: all 0.2s;
  margin: 0;
  margin-left: ${props => props.$first ? '0' : '-1px'};
  margin-right: ${props => props.$first ? '5px' : '0'};
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: ${props => props.$active ? '#4c6ef5' : 'rgba(0, 0, 0, 0.03)'};
    z-index: 1;
  }
  
  &:active {
    background: ${props => props.$active ? '#3b5fc2' : 'rgba(0, 0, 0, 0.05)'};
  }
  
  &:first-child {
    border-radius: 4px 0 0 4px;
    margin-left: 0;
  }
  
  &:last-child {
    border-radius: 0 4px 4px 0;
  }
  
  &:only-child {
    border-radius: 4px;
  }
`

export const SettingCard = styled.div`
  padding: 12px;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  margin-bottom: 10px;
  
  &:hover {
    border-color: rgba(92, 124, 250, 0.2);
    box-shadow: 0 2px 8px rgba(92, 124, 250, 0.08);
  }
`

export const SettingTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 8px;
`

export const SettingContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  
  input {
    flex: 1;
    max-width: 120px;
    padding: 4px 8px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    font-size: 13px;
    
    &:focus {
      outline: none;
      border-color: #5c7cfa;
      box-shadow: 0 0 0 2px rgba(92, 124, 250, 0.1);
    }
  }
  
  button {
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 500;
    color: white;
    background: #ff4d4f;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    
    &:hover {
      background: #ff7875;
    }
  }
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: rgba(0, 0, 0, 0.45);
  
  .icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.3;
  }
  
  .title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
  }
  
  .description {
    font-size: 13px;
  }
`

export const TableWrapper = styled.div`
  background: white;
  border-radius: 6px;
  overflow: hidden;
  
  .ag-theme-alpine {
    --ag-border-color: rgba(0, 0, 0, 0.06);
    --ag-header-background-color: #f8f9fa;
    --ag-header-foreground-color: rgba(0, 0, 0, 0.85);
    --ag-row-hover-color: rgba(92, 124, 250, 0.03);
    
    .ag-header-cell {
      font-size: 12px;
      font-weight: 600;
    }
    
    .ag-cell {
      font-size: 12px;
    }
  }
`